import { handleActions } from 'redux-actions';
import { SHOW_MODAL, SET_SCREEN } from '../constants';

const initialState = {
  show: false,
  modal: 'select',
};

const modalReducer = handleActions(
  {
    [SHOW_MODAL]: (state, { payload }) => ({ ...state, show: payload.show }),
    [SET_SCREEN]: (state, { payload }) => ({ ...state, modal: payload.modal }),
  },
  initialState,
);

export default modalReducer;
